import { render, staticRenderFns } from "./ipt-num.vue?vue&type=template&id=60a74f5a&scoped=true&"
import script from "./ipt-num.vue?vue&type=script&lang=ts&"
export * from "./ipt-num.vue?vue&type=script&lang=ts&"
import style0 from "./ipt-num.vue?vue&type=style&index=0&id=60a74f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a74f5a",
  null
  
)

export default component.exports